export default class LogicGroup {
    constructor(parentRealGroup) {
        this.children = [];
        this.parent = parentRealGroup;
    }

    add(sprite) {
        this.children.push(sprite);
        this.parent.add(sprite);
        let oldDestroy = sprite.destroy;
        sprite.destroy = (a, b, c) => {
            this.children.splice(this.children.indexOf(sprite), 1);
            oldDestroy.call(sprite, a, b, c);
        }

    }

    addAll(sprites) {
        sprites.forEach((s) => this.add(s));
    }

    filter(cb) {
       return this.children.filter(cb);
    }

    forEach(prop, cb) {
        if (typeof prop === 'function' && typeof cb === 'undefined') {
            this.children.forEach(prop);
        } else {
            for (let c of this.children) {
                if (c[prop]) {
                    cb(c);
                }
            }
        }
    }

    count(type) {
        let count = 0;
        for (let c of this.children) {
            if (c.type === type && (c.standing || c.holding || c.flying)) {
                count++;
            }
        }
        return count;
    }

    removeItem(item) {
        if (!item) return;
        item.setDestroyed();
    }

    forEachStanding(cb) {
        this.forEach('standing', cb);
    }

    forEachWalking(cb) {
        this.forEach('walking', cb);
    }

    forEachFlying(cb) {
        this.forEach('flying', cb);
    }

    forEachAlive(cb) {
        for (let c of this.children) {
            if (c.alive) {
                cb(c);
            }
        }
    }

    forEachNotHolding(cb) {
        for (let c of this.children) {
            if (!c.holding) {
                cb(c);
            }
        }
    }

    getClosestTo(object, cb, ctx) {
        return Phaser.Group.prototype.getClosestTo.call(this, object, cb, ctx);
    }



    get total() { return this.children.length; }


}


// WEBPACK FOOTER //
// ./src/states/logic_group.js